<div class="page-not-found" fxLayout="column" fxLayoutAlign="center center">
  <!-- <svg-icon src='../../assets/images/error/404.svg' [svgStyle]="{ 'width.px':350, 'height.px': 350 }"></svg-icon> -->
  <h1 style="margin: 20px 0px">Ooops... 404!</h1>
  <h5>The page you requested could not be found.</h5>
  <a style="font-weight: 600; margin-top: 10px" [routerLink]="['/']"> Back to Shop </a>
</div>
